import { useEffect, useState } from "@wordpress/element";

import CountUP from '../../includes/CountUp'

import { useDashboard } from '../../context/DashboardContext';

export default function OrdersTable({loadingState, response, redirect}) {
    const { data: { accounting }, downloadOrderInvoice } = useDashboard();
    const [downloadingId, setDownloadingId] = useState(null);

    useEffect(() => {}, [loadingState, response]);

    const handleDownload = async orderId => {
        if (!orderId) {
            return;
        }

        try {
            setDownloadingId(orderId);
            await downloadOrderInvoice(orderId);
        } catch (error) {
            // Error is already handled in downloadOrderInvoice
        } finally {
            setDownloadingId(null);
        }
    };

    const hasItems = Array.isArray(response?.items) && response.items.length > 0;

    return (
        <div className="block w-full p-6 bg-white border border-gray-200 rounded-lg shadow-sm orders-table">
                <div class="flex items-baseline justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 bg-white">
                    <div className="flex items-baseline">
                        <h3 className="component-heading">Recent Wholesale Orders</h3>
                    </div>
                </div>
            <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table class="w-full text-sm text-left rtl:text-right">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Order
                            </th>
                            <th scope="col" class="px-6 py-3">
                                User Role
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Status
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Total
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Date
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        { ! loadingState ? (
                            hasItems ? response.items.map(item => (
                            <tr key={item?.id} class="bg-white border-b border-gray-200 hover:bg-gray-50">
                                <td class="px-6 py-4">
                                    {item?.order}
                                </td>
                                <td class="px-6 py-4">
                                    {item?.role}
                                </td>
                                <td class="px-6 py-4" dangerouslySetInnerHTML={{ __html: item?.status }}></td>
                                <td class="px-6 py-4">
                                    <CountUP end={item?.total} accounting={accounting} />
                                </td>
                                <td class="px-6 py-4">
                                    {item?.date}
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        style={{ gap: '5px' }}
                                        disabled={downloadingId === item?.id}
                                        onClick={() => handleDownload(item?.id)}
                                        class={`text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2 ${downloadingId === item?.id ? 'opacity-60 cursor-not-allowed' : ''}`}
                                    >
                                        <svg class="w-3 h-3 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 14">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1v12m0 0 4-4m-4 4L1 9"></path>
                                        </svg>
                                        {downloadingId === item?.id ? 'Downloading...' : 'Download'}
                                    </button>
                                </td>
                            </tr>
                        )) : (
                            <tr class="bg-white border-b border-gray-200">
                                <td class="px-6 py-4 text-center text-sm text-gray-500" colSpan="6">
                                    No wholesale orders found for this period.
                                </td>
                            </tr>
                        )) : (
                            <Skeleton />
                        )}
                    </tbody>
                </table>
                <div className="w-full text-center bg-gray-50 px-6 py-3 text-sm"><a href={redirect}>View Full Table</a></div>
            </div>
        </div>
    );
}

function Skeleton() {
    return (
        <>
        {[...Array(5)].map((_, i) => (
            <tr key={i} class="bg-white border-b border-gray-200 animate-pulse">
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-32"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-40"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-24"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-4 bg-gray-200 rounded w-28"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-5 bg-gray-200 rounded w-20"></div>
                </td>
                <td class="px-6 py-4">
                    <div class="h-5 bg-gray-200 rounded w-20"></div>
                </td>
            </tr>
        ))}
    </>
    );
}